"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var parseDateToGermanDateString = function parseDateToGermanDateString(date) {
  if (!isValidDate(date)) return date;
  var options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  };
  return date.toLocaleDateString("de-DE", options);
};
var isValidDate = function isValidDate(date) {
  return new Date(date) !== "Invalid Date" && !isNaN(new Date(date));
};
var _default = parseDateToGermanDateString;
exports.default = _default;